import React from "react";
import { Routes, Route } from "react-router-dom";
import Onboarding from "../pages/Onboarding/Onboarding";
import PaymentSuccess from "../pages/Onboarding/PaymentSuccess"
import ProgressSuccess from "../pages/Onboarding/ProgressSuccess"
import RootLayout from "../layout";
import PractitionerLayout from "../practitionerLayout";
import PractitionerListing from "../pages/Practitioner/PractitionerListing/PractitionerListing";
import PractitionerSettings from "../pages/Practitioner/PractitionerSettings/PractitionerSettings";
import PractitionerDetails from "../pages/Practitioner/PractitionerDetails/PractitionerDetails";
import PractitionerEdit from "../pages/Practitioner/PractitionerEdit/PractitionerEdit";
import Signup from "../pages/Auth/Signup";
import { loadStripe } from "@stripe/stripe-js";
import RequireAuth from "../requireAuth";

const RouterConfig = () => {
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

  return (
    <Routes>
      <Route path="/" element={<RootLayout />}>
        <Route path="/onboard" element={<Onboarding stripePromise={stripePromise} />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/payment-success" element={<PaymentSuccess stripePromise={stripePromise} />} />
        <Route path="/progress-success" element={<ProgressSuccess stripePromise={stripePromise} />} />
      </Route>
      <Route path="/practitioner" element={<PractitionerLayout />}>
        <Route path="newboard" element={<RequireAuth><Onboarding stripePromise={stripePromise} /></RequireAuth>} />
        <Route path="payment-success" element={<RequireAuth><PaymentSuccess stripePromise={stripePromise} /></RequireAuth>} />
        <Route path="listing" element={<RequireAuth><PractitionerListing /></RequireAuth>} />
        <Route path="edit/:clinicId" element={<RequireAuth><PractitionerEdit stripePromise={stripePromise} /></RequireAuth>} />
        <Route path="settings" element={<RequireAuth><PractitionerSettings /></RequireAuth>} />
      </Route>
      <Route path="/clinic/details/:clinicId" element={<RequireAuth><PractitionerDetails /></RequireAuth>} />
    </Routes>
  );
};

export default RouterConfig;
